export function NetworkBackground() {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden" style={{ zIndex: 1 }}>
      {/* Ambient gradient background */}
      <div className="absolute top-0 left-1/4 h-[600px] w-[600px] rounded-full bg-primary-600/30 blur-[100px]" />
      <div className="absolute bottom-1/4 right-1/4 h-[500px] w-[500px] rounded-full bg-accent-400/25 blur-[80px]" />
      <div className="absolute top-1/2 right-1/3 h-[400px] w-[400px] rounded-full bg-vine-500/25 blur-[80px]" />

      {/* Animated Network Visualization */}
      <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          {/* Gradient for cyan lines */}
          <linearGradient id="lineGradientCyan" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#38BDF8" stopOpacity="0.2" />
            <stop offset="50%" stopColor="#38BDF8" stopOpacity="1" />
            <stop offset="100%" stopColor="#38BDF8" stopOpacity="0.2" />
          </linearGradient>
          {/* Gradient for green lines */}
          <linearGradient id="lineGradientGreen" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#22C55E" stopOpacity="0.2" />
            <stop offset="50%" stopColor="#22C55E" stopOpacity="1" />
            <stop offset="100%" stopColor="#22C55E" stopOpacity="0.2" />
          </linearGradient>
          {/* Glow filter for nodes */}
          <filter id="nodeGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="6" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
          {/* Stronger glow for larger nodes */}
          <filter id="nodeGlowStrong" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="10" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>

        {/* Network connection lines */}
        <g style={{ opacity: 0.8 }}>
          {/* Horizontal connections */}
          <line x1="5%" y1="20%" x2="30%" y2="25%" stroke="url(#lineGradientCyan)" strokeWidth="3" className="animate-network-pulse" />
          <line x1="70%" y1="15%" x2="95%" y2="20%" stroke="url(#lineGradientGreen)" strokeWidth="3" className="animate-network-pulse" style={{ animationDelay: '0.5s' }} />
          <line x1="8%" y1="70%" x2="35%" y2="65%" stroke="url(#lineGradientGreen)" strokeWidth="3" className="animate-network-pulse" style={{ animationDelay: '1s' }} />
          <line x1="65%" y1="75%" x2="92%" y2="70%" stroke="url(#lineGradientGreen)" strokeWidth="3" className="animate-network-pulse" style={{ animationDelay: '1.5s' }} />
          <line x1="12%" y1="45%" x2="40%" y2="42%" stroke="url(#lineGradientGreen)" strokeWidth="3" className="animate-network-pulse" style={{ animationDelay: '2s' }} />
          <line x1="60%" y1="55%" x2="88%" y2="50%" stroke="url(#lineGradientCyan)" strokeWidth="3" className="animate-network-pulse" style={{ animationDelay: '2.5s' }} />

          {/* Diagonal connections */}
          <line x1="18%" y1="28%" x2="42%" y2="48%" stroke="url(#lineGradientGreen)" strokeWidth="3" className="animate-network-pulse" style={{ animationDelay: '0.3s' }} />
          <line x1="58%" y1="42%" x2="82%" y2="28%" stroke="url(#lineGradientGreen)" strokeWidth="3" className="animate-network-pulse" style={{ animationDelay: '0.8s' }} />
          <line x1="22%" y1="58%" x2="48%" y2="45%" stroke="url(#lineGradientCyan)" strokeWidth="3" className="animate-network-pulse" style={{ animationDelay: '1.3s' }} />
          <line x1="52%" y1="52%" x2="78%" y2="68%" stroke="url(#lineGradientGreen)" strokeWidth="3" className="animate-network-pulse" style={{ animationDelay: '1.8s' }} />
          <line x1="28%" y1="82%" x2="52%" y2="62%" stroke="url(#lineGradientGreen)" strokeWidth="3" className="animate-network-pulse" style={{ animationDelay: '2.3s' }} />
        </g>

        {/* Network nodes - Large and bright */}
        <g filter="url(#nodeGlowStrong)">
          {/* Left side nodes */}
          <circle cx="5%" cy="20%" r="8" fill="#38BDF8" className="animate-node-pulse" />
          <circle cx="18%" cy="28%" r="10" fill="#22C55E" className="animate-node-pulse" style={{ animationDelay: '0.5s' }} />
          <circle cx="8%" cy="70%" r="8" fill="#22C55E" className="animate-node-pulse" style={{ animationDelay: '1s' }} />
          <circle cx="22%" cy="58%" r="8" fill="#22C55E" className="animate-node-pulse" style={{ animationDelay: '1.5s' }} />
          <circle cx="12%" cy="45%" r="7" fill="#38BDF8" className="animate-node-pulse" style={{ animationDelay: '2s' }} />
          <circle cx="28%" cy="82%" r="6" fill="#22C55E" className="animate-node-pulse" style={{ animationDelay: '2.5s' }} />

          {/* Center nodes */}
          <circle cx="42%" cy="48%" r="12" fill="#22C55E" className="animate-node-pulse" style={{ animationDelay: '0.3s' }} />
          <circle cx="48%" cy="45%" r="10" fill="#38BDF8" className="animate-node-pulse" style={{ animationDelay: '0.8s' }} />
          <circle cx="52%" cy="52%" r="10" fill="#22C55E" className="animate-node-pulse" style={{ animationDelay: '1.3s' }} />
          <circle cx="52%" cy="62%" r="8" fill="#22C55E" className="animate-node-pulse" style={{ animationDelay: '1.8s' }} />

          {/* Right side nodes */}
          <circle cx="82%" cy="28%" r="10" fill="#22C55E" className="animate-node-pulse" style={{ animationDelay: '0.2s' }} />
          <circle cx="95%" cy="20%" r="8" fill="#38BDF8" className="animate-node-pulse" style={{ animationDelay: '0.7s' }} />
          <circle cx="78%" cy="68%" r="8" fill="#22C55E" className="animate-node-pulse" style={{ animationDelay: '1.2s' }} />
          <circle cx="92%" cy="70%" r="9" fill="#22C55E" className="animate-node-pulse" style={{ animationDelay: '1.7s' }} />
          <circle cx="88%" cy="50%" r="8" fill="#38BDF8" className="animate-node-pulse" style={{ animationDelay: '2.2s' }} />
          <circle cx="70%" cy="15%" r="7" fill="#22C55E" className="animate-node-pulse" style={{ animationDelay: '0.4s' }} />
        </g>

        {/* Data flow particles */}
        <g filter="url(#nodeGlow)">
          <circle r="5" fill="#22C55E">
            <animateMotion dur="4s" repeatCount="indefinite" path="M50,150 Q200,250 400,200 T750,220" />
            <animate attributeName="opacity" values="0;1;1;0" dur="4s" repeatCount="indefinite" />
          </circle>
          <circle r="5" fill="#38BDF8">
            <animateMotion dur="5s" repeatCount="indefinite" path="M800,100 Q600,180 350,150 T50,250" />
            <animate attributeName="opacity" values="0;1;1;0" dur="5s" repeatCount="indefinite" />
          </circle>
          <circle r="4" fill="#22C55E">
            <animateMotion dur="6s" repeatCount="indefinite" path="M100,350 Q350,280 550,320 T950,280" />
            <animate attributeName="opacity" values="0;1;1;0" dur="6s" repeatCount="indefinite" />
          </circle>
          <circle r="5" fill="#22C55E">
            <animateMotion dur="7s" repeatCount="indefinite" path="M900,400 Q650,340 450,370 T80,320" />
            <animate attributeName="opacity" values="0;1;1;0" dur="7s" repeatCount="indefinite" />
          </circle>
        </g>
      </svg>
    </div>
  )
}
